export default __webpack_public_path__ + "static/media/KitosPaslaugos.82059074.svg";